// Single source of truth for booking flags
export const FEATURES = { 'use-whatsapp': 1 }

// Handy boolean for components
export const useWhatsApp = !!FEATURES['use-whatsapp']
